var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "top-bar" }, [
      _c("div", { staticClass: "cwrap" }, [
        _c(
          "ul",
          { staticClass: "topbar-links" },
          [
            _c("li", [_vm._v("您好！欢迎来到新版账户中心")]),
            _vm._v(" "),
            !_vm.isLogin
              ? [_vm._m(0)]
              : [
                  _vm.userData.regStep == 0
                    ? _c("li", [
                        _c("a", { attrs: { href: "/" } }, [
                          _vm._v(
                            _vm._s(_vm.userData.first_name) +
                              _vm._s(_vm.userData.sex == 1 ? "先生" : "女士")
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isLogin
                    ? _c("li", [
                        _c("a", { on: { click: _vm.logout } }, [_vm._v("退出")])
                      ])
                    : _vm._e()
                ],
            _vm._v(" "),
            _vm._m(1)
          ],
          2
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "header bxsh" }, [
      _c("div", { staticClass: "cwrap" }, [
        _c("div", { staticClass: "logo" }, [
          _c(
            "a",
            { attrs: { href: "javascript:;" }, on: { click: _vm.backIndex } },
            [
              _c("img", {
                attrs: { src: "/accountcenter/static/images/logo.png", alt: "" }
              })
            ]
          )
        ]),
        _vm._v(" "),
        _c("ul", { staticClass: "navigation" })
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticStyle: { padding: "0 13px" } }, [
      _c("a", { attrs: { href: "/accountcenter/login.html" } }, [
        _vm._v("【登录】")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c(
        "a",
        {
          attrs: {
            href: "http://www.win-stock.com.cn/product/soft/benefits.html"
          }
        },
        [_vm._v("软件购买")]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-576b9cf5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-576b9cf5","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/top.vue
// module id = mU6b
// module chunks = 1 2 3 4 5 6 7 8